import { AxiosResponse } from 'axios';
import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { PermissionsChangePayload } from '@nx-frontend/shared/types';

export async function updatePermissions(payload: PermissionsChangePayload): Promise<AxiosResponse['data']> {
  try {
    return await axiosClient.post(`${generalEnv.nextApiPath}/permissions`, payload);
  } catch (err) {
    throw new Error('Internal error');
  }
}
